import {Droplets, ArrowRight} from 'lucide-react'

export default function CTASection() {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 rounded-3xl p-8 sm:p-12 lg:p-16 relative overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-sky-500/10 rounded-full blur-3xl" />

          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/15 border border-emerald-400/30 mb-6">
              <Droplets className="w-3.5 h-3.5 text-emerald-400" />
              <span className="text-xs font-semibold text-emerald-300 uppercase tracking-wide">Beyond Fat</span>
            </div>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-5">
              Why You Need to Calculate Water Intake for Weight Loss Success
            </h2>

            <p className="text-gray-400 leading-relaxed mb-8 text-sm sm:text-base">
              Fat metabolism requires adequate hydration. Studies show that drinking 500ml of water
              increases metabolic rate by 30% for up to 40 minutes. Combining your optimal fat intake
              with proper hydration creates a powerful synergy for weight loss. Don't leave half the
              equation unsolved.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="#water"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-emerald-500 text-white font-semibold rounded-xl hover:bg-emerald-600 transition-all shadow-lg hover:shadow-emerald-500/25 hover:-translate-y-0.5"
              >
                Calculate Water Intake
                <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="#calculator"
                className="inline-flex items-center justify-center px-6 py-3.5 bg-white/10 text-white font-medium rounded-xl hover:bg-white/20 transition-all border border-white/20"
              >
                Recalculate Fat Intake
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
